module.exports = __webpack_public_path__ + "img/ico_captain_active.804d003b.png";